<template>
  <!-- <v-card class="notepad-main-container" :max-width="fullscreen ? '100%' : '580px'" :min-height="fullscreen ? '100%' : '680px'"> -->
  <v-card :class="fullscreen ? '' : 'notepad-main-container'" :style="fullscreen ? '' : `height: ${windowHeight - 100}px;`">
    <div v-if="loadingNotes" class="loading-notes">
      <img :src="`${basePath}images/loader.gif`" alt="loading">
    </div>
    <!-- Inicioo Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir essa Anotação" :dialog="dialogDelete" @confirm="deleteNote" @cancel="closeDialogNote"></p-confirm>
    <!-- FIM Dialog para confirmação de exclusão-->
    <!-- Inicioo Dialog para fazer upgrade-->
    
    <p-upgrade-dialog @closeDialog="dialogNotepadTask = false" :upgradeDialog="dialogNotepadTask" :link_src="'https://www.youtube.com/embed/uR1A3c73lNg'"></p-upgrade-dialog>
    
    <!-- FIM Dialog para fazer upgrade-->
    <!-- Inicioo Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir essa Anotação" :dialog="dialogDelete" @confirm="deleteNote" @cancel="closeDialogNote"></p-confirm>
    <!-- FIM Dialog para confirmação de exclusão-->
    <!-- Inicioo Dialog para editar o titulo-->
    <v-dialog v-model="dialogEdit" max-width="500px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">Editar título da Anotação</span>
          <v-spacer></v-spacer>
          <v-btn @click="openDialogDelete(tab)" outline color="pink">Excluir</v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-form @keyup.native.esc="closeDialogNote" @keyup.native.ctrl.enter="editNote" ref="formNote">
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <v-text-field maxlength="10" counter="10" label="título" ref="title"
                                v-model="editedItem.title" :rules="requiredRule('título')"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" :loading="loading" truecolor="primary darken-2" @click.native="editNote">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="closeDialogNote" :loading="loading">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM Dialog para editar o titulo-->
    <!-- Inicioo Dialog para selecionar uma tarefa quando for transformar em listagem ou comentário-->
    <v-dialog v-model="dialogBecome" max-width="500px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="display-1">Criar em {{this.valuesBecome.type === 1 ? 'Comentário' : 'Listagem'}}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-form @keyup.native.esc="closeDialogBecome" @keyup.native.ctrl.enter="become" ref="formBecome">
              <v-layout wrap justify-center align-center>
                <v-flex xs12>
                  <p-tasks-illis ref="tasksIllis" v-model="valuesBecome.task_id" :label="translate('table.tasks.title')[0]" :rules="requiredRule(translate('table.tasks.title')[0])"></p-tasks-illis>
                </v-flex>
                <!-- Apenas mostra pra inserir um titulo se for pra criar uma listagem que é o type 2 -->
                <v-flex xs12 v-if="valuesBecome.type === 2" >
                  <v-text-field maxlength="190" counter="190"  label="Título da listagem" v-model="valuesBecome.title" :rules="requiredRule(translate('table.task_checklist.title')[0])"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="saveBecome(tab)">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="closeDialogBecome" :loading="loading">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM Dialog para selecionar uma tarefa quando for transformar em listagem ou comentário-->
    <!-- z-index adicionado pois quando esta em tela cheia as opções do transformar em tarefa não aparecem -->

    <!-- isRecordRunning usado para identificar de forma mais precisa quando está com o audio ativo (para conseguir usar uma simulação do continuous) -->
    <input v-show="false" type="checkbox" id="isRecordRunning">
    <v-toolbar dark class="theme--dark primary" :style="loadingNotes ? '' : 'z-index: 9999!important'">
      <v-toolbar-title>Bloco de Notas {{this.offline ? ' (Offline)' : ''}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="pr-1">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-menu v-on="on" v-show="!offline" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :style="`height: 40px; background: #027d8d; border-radius: 5px; color: #fff;${checkIsFree()?'padding-right: 0px!important;':''}`" v-on="on" :disabled="(isRecordingActived === true)" @click="checkIsFree() ? (dialogNotepadTask = true) : ''"><v-icon class="pr-1">transform</v-icon>Tarefa <img v-if="checkIsFree()" src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px" style="padding-left: 5px;padding-right: 5px;"></v-btn>
              </template>
              <v-list>
                <v-list-tile @click="(becomeTask())" :disabled="checkIsFree()">
                  <v-list-tile-content>
                    <v-list-tile-title>Transformar em Tarefa</v-list-tile-title>
                    <v-list-tile-sub-title>Transforme sua seleção em uma tarefa</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="openBecome(1)" :disabled="checkIsFree()">
                  <v-list-tile-content>
                    <v-list-tile-title>Transformar em Comentário</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="openBecome(2)" :disabled="checkIsFree()">
                  <v-list-tile-content>
                    <v-list-tile-title>Transformar em Listagem</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
          <span>Transformar anotação em tarefa</span>
        </v-tooltip>
      </v-toolbar-items>
        <v-btn style="height: 40px; background: #027d8d; border-radius: 5px; color: #fff;" :disabled="loadingNewNote || (isRecordingActived === true)" :loading="loadingNewNote" @click="newNotepad">
          <v-icon class="pr-1">add</v-icon>Nota
        </v-btn>
        <v-spacer></v-spacer>
        <v-tooltip bottom v-if="!$vuetify.breakpoint.smAndDown">
          <v-btn v-if="fullscreen" slot="activator" small fab icon @click="$emit('openFullscreen')" :disabled="(isRecordingActived === true)"><v-icon>close_fullscreen</v-icon></v-btn>
          <v-btn v-else slot="activator" small fab icon @click="$emit('openFullscreen')" :disabled="(isRecordingActived === true)"><v-icon>open_in_full</v-icon></v-btn>
          <span>{{ fullscreen ? 'Fechar tela cheia' : 'Abrir em tela cheia' }}</span>                  
        </v-tooltip>
        <v-tooltip bottom v-if="offline">
          <v-btn icon slot="activator" @click="reloadPage()"><v-icon>replay</v-icon></v-btn>
          <span>Atualizar página</span>                  
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="closeNotepad()"><v-icon>close</v-icon></v-btn>
          <span>Fechar</span>                  
        </v-tooltip>
    </v-toolbar>
    <v-card-text style="padding: 0px">
      <v-tabs light v-model="tab" @change="changeTabNote" show-arrows slider-color="blue">
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="(item, index) in items" :key="index" :disabled="isRecordingActived === true">
          <span>{{ item.title }}</span>
          <span v-if="tab === index">
            <v-tooltip bottom v-if="$vuetify.breakpoint.smAndDown">
              <v-btn slot="activator" style="background-color: #F5F5F5; height: 30px; width: 30px;" fab icon @click="openDialogEdit(tab)">
                <v-icon style="font-size: 15px;" color="teal">build</v-icon>
              </v-btn>
              <span>Editar Título da Anotação</span>
            </v-tooltip>
            <v-menu
              v-else
              left
              nudge-top="8"
              content-class="elevation-0 menu_content"
              transition="slide-x-reverse-transition"
              :offset-x="true"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab small slot="activator" v-on="on" icon class="mx-0">
                  <v-icon medium>more_vert</v-icon>
                </v-btn>
              </template>
              <v-tooltip bottom>
                <v-btn slot="activator" style="background-color: #F5F5F5; height: 23px; width: 23px; margin: 8px 1px;" fab @click="openDialogEdit(tab)">
                  <v-icon style="font-size: 15px;" color="teal">build</v-icon>
                </v-btn>
                <span>Editar Título da Anotação</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn slot="activator" style="background-color: #F5F5F5; height: 23px; width: 23px; margin: 8px 1px;" fab @click="openDialogDelete(tab)">
                  <v-icon style="font-size: 15px;" color="pink">delete</v-icon>
                </v-btn>
                <span>Excluir Anotação</span>
              </v-tooltip>
            </v-menu>
          </span>
        </v-tab>
      </v-tabs>
      <v-form @keyup.native.esc="$emit('closeNotepad')">
        <p-text-editor ref="noteEditor" @change="(val)=>{changeNoteEditor(val, tab)}" :saveInterval="2000" :height="windowHeight - (fullscreen ? 140 : 235)"></p-text-editor>
      </v-form>
    </v-card-text>
    <v-card-actions style="padding: 0px">
      <span v-if="isRecordSuported">
        <!-- // Quando for em smarthphone habilitar função de pressionar e soltar -->
        <v-btn v-if="isRecordingActived" outline fab small color="red" @click="stopRecording()"
          style="position: absolute; bottom: 40px;right: 3px;z-index: 9;box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px
          rgba(0,0,0,0.12); background: #fff !important;">
          <v-icon medium>pause</v-icon>
        </v-btn>
        <v-btn v-else outline fab small color="primary" @click="startRecording()" id="record"
          style="position: absolute;bottom: 40px;right: 3px;z-index: 9;box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px
          rgba(0,0,0,0.12); background: #fff !important;">
          <v-icon medium>mic</v-icon>
        </v-btn>
      </span>
      <span v-else>
        <v-tooltip bottom>
          <v-btn disabled slot="activator" outline fab small color="primary"
            style="position: absolute;bottom: 40px;right: 3px;z-index: 9;box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px
            rgba(0,0,0,0.12); background: #fff !important;">
            <v-icon medium>mic</v-icon>
          </v-btn>
          <span>Esse dispositivo não possui suporte gravar áudio nesse bloco!</span>
        </v-tooltip>
      </span>
      <v-layout align-right justify-space-between row fill-height>
        <v-flex xs3>
          <span v-show="saving" style="font-size: 1.1em;color: #1f5f12">Salvando...</span>
        </v-flex>
        <v-flex :class="saving ? 'xs9' : 'xs12'" justify-right>
          <div v-if="editorLengthLimit <= 100" style="text-align: right; font-size: 1.1em;">{{this.editorLengthLimit}}%</div>
          <div v-else style="text-align: right;">
            <div style="font-size: 1.1em; color: red;">Tamanho limite excedido! Alterações não serão salvas. {{this.editorLengthLimit}}%</div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
  .loading-notes{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #00000090;
    z-index: 999;
  }

  .loading-notes img{
    width: 85px;
  }
  .menu_content {
    padding: 0 10px 10px 10px;
  }
  .notepad-main-container{
    background-color:#F5F5F5;
    border: 1px solid #024b7c;
    width:580px;
    overflow: hidden;
    position: fixed;
    bottom: 36px;
    right: 0px;
  }

  .v-toolbar__content{
    padding-right: 5px !important;
  }
</style>

<script>
  /* eslint-disable */
  import localforage from 'localforage'
  import PConfirm from './../shared/PConfirm'
  import PTasksIllis from './../shared/PTasksIllis'
  import imageCompress from './../../mixin/imageCompress'
  import PTextEditor from './../shared/PTextEditor'
  import PUpgradeDialog from './../shared/PUpgradeDialog'
  import rules from './../../mixin/rules'
  import plan from './../../mixin/plan'
  import {isRecordActived, getRecordtext, setRecordtext, recordtextIsFinal, startRecord, stopRecord} from './../../record.js' 
  export default {
    mixins: [rules, plan, imageCompress],
    components: {PConfirm, PTasksIllis, PTextEditor, PUpgradeDialog},
    props: [ 'fullscreen' ],
    data: function () {
      return {
        valuesBecome: {task_id: null, title: '', type: null},
        editedItem: {id:'', title: '', id_text: ''},
        // possui a instancia da tabela offline do bloco de anotações
        localforageNotepad: {},
        // possui a instancia da tabela offline que armazena todas as alterações feitas 
        localforageChanges: {},
        isRecordSuported: true,
        saveTimeout: null,
        fab: null,
        tab: null,
        setKeyup: null,
        dialogNotepadTask: false,
        dialogBecome: false,
        dialogDelete: false,
        dialogEdit: false,
        intervalRecording: null,
        isRecordingActived: false,
        getRecordingtext: '',
        // Variável para salvar o valor de texto completo ou selecionado para transforma-lo em listagem ou comentário, pois estava perdendo a seleção
        textBecome: '',
        saving: false,
        offline: false,
        loadingNewNote: false,
        items: [{id: 1, title: 'OffLine', id_text: ''}],
        loadingNotes: false,
        windowHeight: 0,
        basePath: process.env.API,
        loading: false
      }
    },
    sockets: {
      // quando acontecer alguma atualização no bloco deve sair do bloco de outras abas para não dar conflito nas informações
      returnFirstTime () {
        if (this.isRecordingActived === true) {
          this.stopRecording()
        }
        this.$emit('returnFirstTime')
        this.$store.commit('snackbar/change_values', { text: 'Seu bloco foi fechado pois está sendo usado em outra aba ou dispositivo!', color: 'info', timeout: 10000, dialog: true })
      }
    },
    created () {
      window.addEventListener('resize', this.resizeScreen)
      this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      this.offline = !navigator.onLine
    },
    mounted () {
      let isRecordSuport = window.SpeechRecognition || window.webkitSpeechRecognition || null
      this.isRecordSuported = isRecordSuport ? true : false
      // cria o banco de dados offline
      this.localforageNotepad = localforage.createInstance({driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE], name: 'illis-offline', version: 1.0, storeName: 'notepad', description: 'tabela nodepad offline'})
      this.localforageChanges = localforage.createInstance({driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE], name: 'illis-offline', version: 1.0, storeName: 'changes', description: 'guarda as alterações offline para passar pro banco depois'})
      this.items = []
      if (this.offline) {
        // Busca os valores offline e vai adicionando no itens
        this.localforageNotepad.iterate((value, key, iterationNumber) => {
          this.items.push(value)
        }).then(() => {
          // Ordena os valores do banco offline pois eles veem odenado considerando o id como string
          this.items = this.items.sort((a, b) => {
            return a.id - b.id
          })
          if (!this.items || this.items.length <= 0) {
            // caso não exita valor offline, cria um
            this.newNotepad('Item 1')
          } else {
            this.tab = 0
            setTimeout(() => {
              this.setNoteEditor(this.items[0].id_text)
            }, 1000)
          }
        }).catch((err) => {
          // This code runs if there were any errors
          console.log(err)
        })
      } else {
        this.initialize()
      }
    },
    methods: {
      resizeScreen() {
        this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      },
      onEditorChange({ quill, html, text }) {
        this.content = html
      },
      initialize (loadingNotes = true) {
        this.loadingNotes = loadingNotes
        this.$http.get(`api/notepad`).then((res) => {
          this.items = res.body
          // zera o banco ooffline para preencher os valores atualizados
          this.localforageNotepad.clear()
          var _this = this
          // Preenche o banco de dados offline
          this.items.forEach((item) => {
            _this.localforageNotepad.setItem(item.id, item)
          })
          if (!this.items || this.items.length <= 0) {
            this.newNotepad('Item 1')
          } else {
            this.tab = 0
            // var _this = this
            setTimeout(() => {
              // _this.setNoteEditor(this.items[0].id_text)
              this.changeTabNote()
            }, 1000)
          }
          // setTimeout incluido para dar tempo dos dados serem processados no bloco e não ficar em brando durante esse tempo
          setTimeout(() => {
            this.loadingNotes = false
          }, 500)
        })
      },
      startRecording () {
        // começa a escutar o audio e a receber ele nas variaveis
        startRecord()
        // setTimeout inserido para dar tempo do esRecordActived receber valor sobre algum erro
        setTimeout(() => {
          if (isRecordActived() === 'error') {
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível iniciar o audio, entre em contato com nosso suporte!',
              color: 'error',
              timeout: 10000,
              dialog: true
            })
            return ''
          }
          // grava o tab no inicio caso o usuário troque de tab
          let tab = this.tab
          document.getElementById('isRecordRunning').checked = true

          this.getRecordingtext = ''
          // caso não tenha valor mudar para o audioillis caso tenha valor apenas adiciona ele
          if (this.items[tab].id_text === null) {
            this.items[tab].id_text = "<audioillis></audioillis>"
          } else {
            this.items[tab].id_text = this.items[tab].id_text + "<audioillis></audioillis>"
          }
          this.intervalRecording = setInterval(() => {
          this.isRecordingActived = isRecordActived()
            var text = getRecordtext()
            // caso de algum erro durante a gravação, para ela
            if (isRecordActived() === 'error') this.stopRecording()
            let id_text = ''
            // caso seja o final da frase do usuário, substifui o audioilllis para começar outro paragrafo
            if (!document.getElementById('isRecordRunning').checked) {
              document.getElementById('isRecordRunning').checked = true
              id_text = (this.items[tab].id_text.replace('<audioillis>' + this.getRecordingtext + '</audioillis>', '<p>' + text[0].toUpperCase() + text.substring(1) + '.</p>'))
              // salva o valor falado no banco
              this.setNoteEditor(id_text)
              this.changeNoteEditor(id_text, tab)
              // Prepara para continuar a gravação
              this.items[tab].id_text = this.items[tab].id_text + "<audioillis></audioillis>"
              this.getRecordingtext = ''
              // seta o valor vazio quando acaba de falar para não vir com valor antigo
              setRecordtext('')
            } else {
              id_text = this.items[tab].id_text.replace('<audioillis>' + this.getRecordingtext + '</audioillis>', '<audioillis>' + text + '</audioillis>')
              // Inclui o valor na anotação
              this.items[tab].id_text = id_text
              this.setNoteEditor(id_text)
            }
            // Altera o valor mostrado
            this.getRecordingtext = text
            // Roda a barra de rolagem pra baixo para ir acompanhando a medida que o usuário vai falando
            let divText = document.getElementById(`rteObj${this.$refs.noteEditor.getRandowId()}_rte-edit-view`)
            divText.scrollTo(0, divText.scrollHeight)
          }, 200)
        }, 300)
      },
      stopRecording () {
        stopRecord()
        this.isRecordingActived = false
        // setTimeout criado pois estava limpando antes de colocar as ultimas palavras
        setTimeout(() => {
          let id_text = this.items[this.tab].id_text.replace('<audioillis></audioillis>', '').replace('<audioillis>', '<p>').replace('</audioillis>', '</p>')
          // substitui os valores caso senha ficado algum com audioillis
          this.setNoteEditor(id_text)
          this.changeNoteEditor(id_text, this.tab)

          clearInterval(this.intervalRecording)
        }, 500)
      },
      changeTabNote () {
        // If inserido pois a primeira vez que o usuário entra no sistema passa pelo changetab mas ainda não foi carregado as tabs
        if (typeof this.tab !== 'undefined') {
          this.setNoteEditor(this.items[this.tab].id_text)
        }
        this.noteFocus()
      },
      changeNoteEditor (val, tab) {
        this.items[tab].id_text = val
        clearTimeout(this.saveTimeout)
        this.saveTimeout = setTimeout(() => {
          this.saveNote(this.tab)
        }, 2000)
      },
      openBecome (type) {
        var selectionRange = window.getSelection()
        if (window.getSelection) {  // all browsers, except IE before version 9
          // Caso o usuário não tenha selecioando nada, pega o valor de toa a anotação
          if (selectionRange.toString() === '') {
            this.textBecome = this.items[this.tab].id_text
          } else {
            // Caso o usuário tenha selecionado pega o html da seleção
            var selText = selectionRange.toString()
            if (selectionRange.rangeCount > 0) {
              var range = selectionRange.getRangeAt(0)
              var docFragment = range.cloneContents()
              var tmpDiv = document.createElement("div")
              tmpDiv.appendChild(docFragment)
              var selHTML = tmpDiv.innerHTML;
              this.textBecome = tmpDiv.innerHTML
            } else {
              this.textBecome = this.items[this.tab].id_text
            }
          }
        } else {// Internet Explorer before version 9
          var textRange = document.selection.createRange()
          this.textBecome = textRange.htmlText;
        }

        if (!this.textBecome) {
          this.$store.commit('snackbar/change_values', {text: 'Digite ou selecione um texto para incluir uma tarefa.', color: 'warning', dialog: true})
          return ''
        }
        this.valuesBecome = {task_id: null, title: '', type: type}
        this.dialogBecome = true
      },
      closeDialogBecome () {
        this.dialogBecome = false
        this.valuesBecome = {task_id: null, title: '', type: null}
      },
      closeNotepad () {
        if (this.isRecordingActived === true) {
          this.stopRecording()
        }
        this.$emit('closeNotepad')
      },
      saveBecome (tab) {
        if (this.saving) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, Aguarde enquanto o bloco está sendo salvo antes de transformar-lo!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        if ((this.$refs.formBecome && !this.$refs.formBecome.validate()) || (this.$refs.tasksIllis && !this.$refs.tasksIllis.validate())) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        // usado o this.textBecome para conseguir salvar o q o usuário selecionou
        let text = this.textBecome
        // cria a estrutura para criar a a listagem ou o comentário
        var values = {}
        if (this.valuesBecome.type === 1) {
          values = {
            task_id: this.valuesBecome.task_id,
            user_id: this.$auth.user().id,
            company_id: this.$auth.user().company_id,
            id_text: text
          }
        } else {
          values = {
            task_id: this.valuesBecome.task_id,
            user_id: this.$auth.user().id,
            company_id: this.$auth.user().company_id,
            id_text: this.valuesBecome.title,
            done: false,
            description: text
          }
        }
        this.$store.commit('loader/change_dialog', true)
        this.loading = true
        this.$http.post(`api/${this.valuesBecome.type === 1 ? 'task_comment' : 'task_checklist' }`, values).then((res) => {
          // Manda os eventos para o proprio usuário para atualizar as paginas de calendario ou de tarefas
          this.$socket.emit('generalDetailsEvent', {
            data: this.valuesBecome.type === 1 ? {comment: res.body, shift: true} : res.body,
            notBroadcast: true,
            details: this.valuesBecome.type === 1 ? 'comments' : 'checklists',
            responseEvent: 'addSocketDetails',
            room: `tasks${res.body.task_id}_manage`
          })
          // atualiza os badges
          this.$socket.emit('generalDetailsEvent', {
            notBroadcast: true,
            details: this.valuesBecome.type === 1 ? 'comments' : 'checklists',
            responseEvent: 'changeBadgeSocketDetails',
            room: `tasks${res.body.task_id}_manage`
          })
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
          if (this.$route.path != `/task/${res.body.task_id}`) {
            // Tab para abrir a tab de acordo com o comentário ou listagem
            this.$router.push(`/task/${res.body.task_id}?tab=${this.valuesBecome.type === 1 ? '0' : '2'}`)
          }
          this.$store.commit('snackbar/change_values', {text: 'Registro de Tarefa incluído com sucesso!', color: 'success', dialog: true})
          this.closeDialogBecome()
        },
        err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de Tarefa, reporte o erro.', color: 'error', dialog: true})
        })
      },
      becomeTask () {
        if (this.saving) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, Aguarde enquanto o bloco está sendo salvo antes de transformar-lo!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        // verifica se existe algo selecionado, se não, pega o texto da pagina atual
        let text = document.getSelection().toString() === '' ? (this.$refs.noteEditor.getValueText() ? this.$refs.noteEditor.getValueText().substr(0, 190) : '') : document.getSelection().toString().substr(0, 190)
        if (!text || text.trim() === '') {
          this.$store.commit('snackbar/change_values', {text: 'Digite ou selecione um texto para incluir uma tarefa.', color: 'warning', dialog: true})
          return ''
        }
        // cria a estrutura para criar a tarefa
        var task = {
          company_id: this.$auth.user().company_id,
          user_id: this.$auth.user().id,
          id_text: text,
          level: 1,
          shared: false
        }
        this.$store.commit('loader/change_dialog', true)
        this.loading = true
        this.$http.post('api/tasks', task).then((res) => {
          // Manda os eventos para o proprio usuário para atualizar as paginas de calendario ou de tarefas
          this.$socket.emit('generalEvent', {
            data: res.body,
            notBroadcast: true,
            responseEvent: 'addSocketItem',
            room: `tasks${this.$auth.user().id}`
          })
          this.$socket.emit('generalEvent', {
            data: res.body,
            notBroadcast: true,
            responseEvent: 'addSocketCalendarTask',
            room: `calendar${this.$auth.user().id}`
          })
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
          this.$router.push(`/task/${res.body.id}`)
          this.$store.commit('snackbar/change_values', {text: 'Registro de Tarefa incluído com sucesso!', color: 'success', dialog: true})
        },
        err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de Tarefa, reporte o erro.', color: 'error', dialog: true})
        })
      },
      saveNote (tab) {
        // caso passe de 150000 mil caracteres não será salvo o valor no banco
        let item = JSON.parse(JSON.stringify(this.items[tab]))
        // verifica se os valores são vazios caso o usuário tenha apagado os valores e se o length é menos que 150000 mil
        if (item.id_text === null || item.id_text === '' || (item.id_text && item.id_text.length <= 150000)) {
          let user_id = JSON.parse(localStorage.getItem('last_user')).id
          this.localforageNotepad.setItem(item.id, item)
          // alteração do arquivo para base64
          if (!this.saving && !this.isRecordingActived) {
            this.saving = true
            this.imgsCompressAndBase64(item.id_text).then(res => {
              item.id_text = res
              if (this.offline) {
                // incluir um registro de um alteração que foi feita para passar pro online quando tiver internet
                this.localforageChanges.setItem(`note${item.id}`, {model: 'Notepad', type: 'update', user_id: user_id, values: item})
              } else {
                // verifica se já está sendo salvo alguma requisição, para não ficar acumulando requisições
                this.$http.put(`api/notepad/${item.id}`, {id_text: item.id_text}).then((res) => {
                  this.saving = false
                  // atualiza outras abas do usuário
                  this.items[tab] = JSON.parse(JSON.stringify(res.body))
                  this.$socket.emit('generalEvent', {
                    responseEvent: 'reloadNotepad',
                    room: `user${this.$auth.user().id}`
                  })
                }, err => {
                  this.$store.commit('snackbar/change_values', {
                    text: 'Não foi possível incluir um bloco de notas, reporte o erro.',
                    color: 'error',
                    dialog: true
                  })
                })
              }
            }, err => {
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível incluir um bloco de notas, reporte o erro.',
                color: 'error',
                dialog: true
              })
            })
          }
        }
        this.saving = false
      },
      openDialogEdit(tab) {
        this.dialogEdit = true
        this.editedItem = JSON.parse(JSON.stringify(this.items[tab]))
        if (this.$refs.title) {
          this.$nextTick(() => this.$refs.title.focus())
        }
      },
      openDialogDelete(tab) {
        this.dialogDelete = true
        this.editedItem = JSON.parse(JSON.stringify(this.items[tab]))
      },
      closeDialogNote() {
        this.dialogDelete = false
        this.dialogEdit = false
        this.editedItem = {id:'', title: '', id_text: ''}
        this.$store.commit('loader/change_dialog', false)
      },
      newNotepad (title = null) {
        title = (title == null) ? title : `Item ${this.items.length + 1}`
        this.loadingNewNote = true
        this.loadingNotes = true
        if (!this.items) this.items = []
        if (this.offline) {
          // pega o menor id para ir subtraindos e colocando ids negativos quando estiver ofline para saber quais itens eram offlines 
          var minId = 0
          this.items.map((item) => {
            minId = (minId < item['id']) ? minId : item['id']
          })
          let values = {id: (minId - 1), user_id: JSON.parse(localStorage.getItem('last_user')).id, title: title}
          this.items.push(values)
          // incluir um registro de um alteração que foi feita para passar pro online quando tiver internet
          this.localforageChanges.setItem(`note${values.id}`, {model: 'Notepad', type: 'create', user_id: JSON.parse(localStorage.getItem('last_user')).id, values: values})
          // inclui o registro no banco offline
          this.localforageNotepad.setItem(values.id, values)
          // setTimeout adicionado pois o push ocorria depois não executando os codigos do setTimeout
          // para ir para a tab que foi adicionada
          setTimeout(() => {
            this.tab = this.items.length - 1
            this.setNoteEditor('<p><br></p>')
            this.noteFocus()
          }, 300)
          this.loadingNewNote = false
          this.loadingNotes = false
        } else {
          this.$http.post(`api/notepad`, {title: title}).then((res) => {
            this.items.push(res.body)
            // setTimeout adicionado pois o push ocorria depois não executando os codigos do setTimeout
            // para ir para a tab que foi adicionada
            setTimeout(() => {
              this.tab = this.items.length - 1
              this.setNoteEditor('<p><br></p>')
              this.noteFocus()
            }, 300)
            // inclui o registro no banco offline
            this.localforageNotepad.setItem(res.body.id, res.body)
            this.loadingNewNote = false
            this.loadingNotes = false
            // atualiza outras abas do usuário
            this.$socket.emit('generalEvent', {
              responseEvent: 'reloadNotepad',
              room: `user${this.$auth.user().id}`
            })
          }, err => {
            console.log(err)
            this.loadingNewNote = false
            this.loadingNotes = false
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível incluir um bloco de notas, reporte o erro.',
              color: 'error',
              dialog: true
            })
          })
        }
      },
      setNoteEditor(text){
        if (this.$refs.noteEditor) {
          this.$refs.noteEditor.setValue(text)
          this.$refs.noteEditor.refresh()
        }
      },
      delete () {
        this.localforageNotepad.removeItem(`${this.editedItem.id}`)
        this.items = this.items.filter((val) => {
          return val.id !== this.editedItem.id
        })
        // Caso seja excluido alguma tab, ela permanecera na mesma posição, mas se a mesma posição já for a ultima, ela ira para a ultima atual
        if (this.tab > this.items.length - 1) {
          this.tab = this.items.length - 1
        }
        this.setNoteEditor(this.items[this.tab].id_text)
        this.noteFocus()
        this.closeDialogNote()
      },
      deleteNote() {
        this.$store.commit('loader/change_dialog', true)
        if (this.items.length <= 1) {
          this.$store.commit('snackbar/change_values', {text: 'Para excluir esse bloco de notas é necessário ter pelo menos 1 blocos criado.', color: 'warning', dialog: true})
          this.$store.commit('loader/change_dialog', false)
          return ''
        }
        if (this.offline) {
          // se o id for maior que 0, significa que está apagando um registro que possui no banco pelo modo offline, portanto deve ser armazenado o id para que o registro seja apagado no banco
          if (this.editedItem.id > 0) {
            // incluir um registro de um alteração que foi feita para passar pro online quando tiver internet
            this.localforageChanges.setItem(`note${this.editedItem.id}`, {model: 'Notepad', type: 'delete', user_id: JSON.parse(localStorage.getItem('last_user')).id, values: {id: this.editedItem.id} })
          } else {
            // se for menos que 0 significa que o registro foi inserido no modo offline, portanto se ele tiver sido excluido não precisa armazenar o valor pra mudar
            this.localforageChanges.removeItem(`note${this.editedItem.id}`)
          }
          this.delete()
        } else {
          this.$http.delete(`api/notepad/${this.editedItem.id}`).then((res) => {
            this.delete()
            // atualiza outras abas do usuário
            this.$socket.emit('generalEvent', {
              responseEvent: 'reloadNotepad',
              room: `user${this.$auth.user().id}`
            })
          }, err => {
            console.log(err)
            this.closeDialogNote()
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível editar um bloco de notas, reporte o erro.',
              color: 'error',
              dialog: true
            })
          })
        }
      },
      edit (item) {
        if (!this.items) {
          this.items = []
        } else {
          Object.assign(this.items.find((val) => {
            return val.id === item.id
          }) || {}, JSON.parse(JSON.stringify(item)))
        }
        this.localforageNotepad.setItem(item.id, JSON.parse(JSON.stringify(item)))
        this.noteFocus()
        this.closeDialogNote()
      },
      editNote() {
        if (this.$refs.formNote && !this.$refs.formNote.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        if (this.offline) {
          this.localforageChanges.setItem(`note${this.editedItem.id}`, {model: 'Notepad', type: 'update', user_id: JSON.parse(localStorage.getItem('last_user')).id, values: this.editedItem})
          this.edit(this.editedItem)
        } else {
          this.$store.commit('loader/change_dialog', true)
          this.loading = true
          this.$http.put(`api/notepad/${this.editedItem.id}`, this.editedItem).then((res) => {
            this.edit(res.body)
            // atualiza outras abas do usuário
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.$socket.emit('generalEvent', {
              responseEvent: 'reloadNotepad',
              room: `user${this.$auth.user().id}`
            })
          }, err => {
            console.log(err)
            this.closeDialogNote()
            this.loading = false
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível editar um bloco de notas, reporte o erro.',
              color: 'error',
              dialog: true
            })
          })
        }
      },
      // Função para focar no textarea da tab atual
      noteFocus () {
        if (this.$refs.noteEditor) this.$refs.noteEditor.focus()
      },
      reloadPage () {
        location.reload(true)
      }
    },
    computed: {
      editorLengthLimit () {
        if ((this.tab !== null) && (this.items.length > 0) && this.items[this.tab].id_text) {
          return Math.round((this.items[this.tab].id_text.length / 150000) * 100)
        } else {
          return 0
        }
      }
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.resizeScreen)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PNotepad.vue